<template>
  <div class="MapAbility"></div>
</template>

<script>
export default {
  name: 'MapAbility',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.MapAbility {
  width: 100%;
  height: 0px;
  background: #ffffff;
  border: 1px solid #979797;
}
</style>
